/* eslint-disable camelcase */
import Vue from 'vue';
import Vuex from 'vuex';

import auth from '@/store/auth';
import formulario from '@/store/formulario';
import headers from '@/store/headers';
import icons from '@/store/icons';
import inicioJustToken from '@/store/inicioJustToken';
import LoadTokenWa from '@/store/LoadTokenWa';
import LoginApiWa from '@/store/LoginApiWa';
import notification from '@/store/notification';
import query from '@/store/query';
import setup from '@/store/setup';
import SICUDdoc_eval_val from '@/store/SICUDdoc_eval_val';
import SICUDdocumentforinstance from '@/store/SICUDdocumentforinstance';
import SICUDgpd_crd_mail from '@/store/SICUDgpd_crd_mail';
import SICUDgpd_est_crd from '@/store/SICUDgpd_est_crd';
import SICUDgpd_est_crd_pas from '@/store/SICUDgpd_est_crd_pas';
import SICUDgpd_est_crd3 from '@/store/SICUDgpd_est_crd3';
import SICUDgpd_inf_cont from '@/store/SICUDgpd_inf_cont';
import SICUDgpd_inf_crd from '@/store/SICUDgpd_inf_crd';
import SICUDgpd_inf_fin from '@/store/SICUDgpd_inf_fin';
import SICUDgpd_lab_crd from '@/store/SICUDgpd_lab_crd';
import SICUDgpd_per_crd from '@/store/SICUDgpd_per_crd';
import SICUDgpd_pr_est from '@/store/SICUDgpd_pr_est';
import SICUDgpd_respuesta from '@/store/SICUDgpd_respuesta';
import SICUDgpd_resul_est from '@/store/SICUDgpd_resul_est';
import SICUDgpd_resul_eval from '@/store/SICUDgpd_resul_eval';
import SICUDsic_hlp_usu from '@/store/SICUDsic_hlp_usu';
import SICUDsic_sal_bol from '@/store/SICUDsic_sal_bol';
import SICUDsic_sal_par from '@/store/SICUDsic_sal_par';
import SICUDsic_tbl from '@/store/SICUDsic_tbl';
import SICUDsubirdoc from '@/store/SICUDsubirdoc';
import SIgetMessage from '@/store/SIgetMessage';
import SIRcon_aut from '@/store/SIRcon_aut';
import SIRcon_aut_mail from '@/store/SIRcon_aut_mail';
import SIRcon_aut_pdf from '@/store/SIRcon_aut_pdf';
import SIRdoc_wgt_url from '@/store/SIRdoc_wgt_url';
import SIRejecutareportes from '@/store/SIRejecutareportes';
import SIRevaluationModule from '@/store/SIRevaluationModule';
import SIRFormulario from '@/store/SIRFormulario';
import SIRgetDocuments from '@/store/SIRgetDocuments';
import SIRgpd_crd_cont from '@/store/SIRgpd_crd_cont';
import SIRgpd_est_crd from '@/store/SIRgpd_est_crd';
import SIRgpd_inf_cont from '@/store/SIRgpd_inf_cont';
import SIRgpd_inf_crd from '@/store/SIRgpd_inf_crd';
import SIRgpd_inf_fin from '@/store/SIRgpd_inf_fin';
import SIRgpd_lab_crd from '@/store/SIRgpd_lab_crd';
import SIRgpd_per_crd from '@/store/SIRgpd_per_crd';
import SIRgpd_resul_eval from '@/store/SIRgpd_resul_eval';
import SIRgpd_resul_rep from '@/store/SIRgpd_resul_rep';
import SIRinitialWeb from '@/store/SIRinitialWeb';
import SIRqsmartBitacora from '@/store/SIRqsmartBitacora';
import SIRQueryDomWa from '@/store/SIRQueryDomWa';
import SIRrep_rpt from '@/store/SIRrep_rpt';
import SIRrep_rpt_det from '@/store/SIRrep_rpt_det';
import SIRsic_hlp from '@/store/SIRsic_hlp';
import SIRsic_msg from '@/store/SIRsic_msg';
import SIRsic_ocr_dcli from '@/store/SIRsic_ocr_dcli';
import SIRsic_param from '@/store/SIRsic_param';
import SIRsic_sal from '@/store/SIRsic_sal';
import SIRsic_sal_bol from '@/store/SIRsic_sal_bol';
import SIRsic_sal_nvg from '@/store/SIRsic_sal_nvg';
import SIRsic_sal_par from '@/store/SIRsic_sal_par';
import SIRsic_tbl from '@/store/SIRsic_tbl';
import SIRsic_usr_asoc from '@/store/SIRsic_usr_asoc';
import SIRsic_usr_nit from '@/store/SIRsic_usr_nit';
import SIRsic_vfc_otp from '@/store/SIRsic_vfc_otp';
import SIsendMessage from '@/store/SIsendMessage';
import socket from '@/store/socket';

Vue.use(Vuex);

export default new Vuex.Store({
  strict: true,

  modules: {
    auth,
    socket,
    formulario,
    headers,
    icons,
    inicioJustToken,
    notification,
    query,
    setup,
    LoadTokenWa,
    LoginApiWa,
    SICUDdoc_eval_val,
    SICUDdocumentforinstance,
    SICUDgpd_crd_mail,
    SICUDgpd_est_crd,
    SICUDgpd_est_crd3,
    SICUDgpd_est_crd_pas,
    SICUDgpd_inf_cont,
    SICUDgpd_inf_crd,
    SICUDgpd_lab_crd,
    SICUDgpd_inf_fin,
    SIRgpd_inf_crd,
    SIRgpd_inf_fin,
    SIRgpd_lab_crd,
    SIRgpd_per_crd,
    SIRgpd_resul_eval,
    SIRgpd_resul_rep,
    SICUDgpd_per_crd,
    SICUDgpd_pr_est,
    SICUDgpd_respuesta,
    SICUDgpd_resul_est,
    SICUDgpd_resul_eval,
    SICUDsic_hlp_usu,
    SICUDsic_sal_bol,
    SICUDsic_sal_par,
    SICUDsubirdoc,
    SICUDsic_tbl,
    SIgetMessage,
    SIRcon_aut,
    SIRcon_aut_mail,
    SIRcon_aut_pdf,
    SIRdoc_wgt_url,
    SIRejecutareportes,
    SIRevaluationModule,
    SIRFormulario,
    SIRgetDocuments,
    SIRgpd_crd_cont,
    SIRgpd_est_crd,
    SIRgpd_inf_cont,
    SIRinitialWeb,
    SIRqsmartBitacora,
    SIRQueryDomWa,
    SIRrep_rpt,
    SIRrep_rpt_det,
    SIRsic_hlp,
    SIRsic_msg,
    SIRsic_ocr_dcli,
    SIRsic_param,
    SIRsic_sal,
    SIRsic_tbl,
    SIRsic_sal_bol,
    SIRsic_sal_nvg,
    SIRsic_sal_par,
    SIRsic_usr_asoc,
    SIRsic_usr_nit,
    SIRsic_vfc_otp,
    SIsendMessage,
  },
});
